import { Link } from "react-router-dom";
import { Check } from "lucide-react";

/**
 * Urban Company / Instamart-style photo tile for a solar service category.
 * Renders as a <Link> when `to` is supplied (Home screen), otherwise as a
 * <button> (Buy Installation picker, which drives in-page form state).
 *
 * variant="compact" -> narrow card for a horizontal snap-scroll row (Home)
 * variant="grid"    -> wider card for a 2-column grid with a selected state
 */
export function CategoryTile({ tile, variant = "grid", to, selected = false, onClick, testId }) {
  const isCompact = variant === "compact";

  const content = (
    <>
      <div className={"relative overflow-hidden " + (isCompact ? "h-[72px]" : "h-24")}>
        <img
          src={tile.image}
          alt={tile.label}
          draggable={false}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 group-active:scale-100"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/0 to-black/0" />
        {selected && (
          <span className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-[#0D4721] text-white flex items-center justify-center shadow-md">
            <Check className="w-3 h-3" strokeWidth={3} />
          </span>
        )}
      </div>
      <div className={"bg-white " + (isCompact ? "px-2 py-1.5" : "px-2.5 py-2")}>
        <div className={"font-bold text-slate-800 leading-tight " + (isCompact ? "text-[11px] line-clamp-2 min-h-[26px]" : "text-[12.5px]")}>
          {tile.label}
        </div>
        {!isCompact && <div className="text-[10px] text-slate-400 font-medium mt-0.5 leading-tight">{tile.subtitle}</div>}
      </div>
    </>
  );

  const className =
    "group text-left rounded-2xl overflow-hidden border-2 bg-white transition-colors duration-150 " +
    (isCompact ? "flex-shrink-0 w-[116px] snap-start " : "w-full ") +
    (selected ? "border-[#0D4721]" : "border-slate-200/80 hover:border-emerald-300");

  if (to) {
    return (
      <Link to={to} data-testid={testId} className={className}>
        {content}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testId} className={className}>
      {content}
    </button>
  );
}
